import { createFileRoute } from "@tanstack/react-router";

import { BookLibrary } from "#/components/BookLibrary";
import { listBooks } from "#/lib/bookling";
import { SITE_DESCRIPTION, SITE_NAME, canonicalLink, seoMeta } from "#/lib/seo";

export const Route = createFileRoute("/books/")({
  loader: () => listBooks(),
  head: () => ({
    meta: seoMeta({
      title: `Books | ${SITE_NAME}`,
      description: SITE_DESCRIPTION,
      path: "/books",
    }),
    // Canonical points at `/` because that route owns the same catalog with
    // the hero copy and the CollectionPage JSON-LD; `/books` is a secondary
    // entry point. Without this, both URLs self-canonical with near-identical
    // bodies and crawlers pick one arbitrarily.
    links: canonicalLink("/"),
  }),
  component: BooksIndex,
});

function BooksIndex() {
  const books = Route.useLoaderData();

  return (
    <main>
      <section className="page-wrap library-section" id="library" aria-label="Library">
        <header className="detail-intro">
          <p className="eyebrow">Bookshelf</p>
          <h1>Every book recommended on GDIY</h1>
          <p>{books.length.toLocaleString()} unique books mentioned across the archive.</p>
        </header>

        <BookLibrary books={books} />
      </section>
    </main>
  );
}
